function Error() {
  return (
    <article>
      <p className='error'>
        <span>💥</span> There was an error fecthing questions.
      </p>
    </article>
  );
}

export default Error;
